import React, { useState, useRef } from "react";
import { Box, Typography, Card, CardMedia } from "@mui/material";
import VideoPlayerModalHotstar from "./VideoPlayerModalHotstar";

const abc = [
  {
    "episodeTitle": "Ep 1 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false,
    "isVideoWatched": true
  },
  {
    "episodeTitle": "Ep 2 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false,
    "isVideoWatched": true
  },
  {
    "episodeTitle": "Ep 3 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false
  },
  {
    "episodeTitle": "Ep 4 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false
  },
  {
    "episodeTitle": "Ep 5 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false
  },
  {
    "episodeTitle": "Ep 6 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false
  },
  {
    "episodeTitle": "Ep 7 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false
  },
  {
    "episodeTitle": "Ep 8 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 9 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 10 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 11 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 12 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 13 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 14 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 15 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 16 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 17 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 18 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 19 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 20 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 21 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 22 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 23 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 24 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 25 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 26 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 27 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 28 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 29 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 30 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 31 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 32 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 33 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 34 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 35 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 36 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 37 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 38 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 39 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 40 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 41 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 42 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 43 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 44 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 45 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 46 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 47 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 48 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 49 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 50 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 51 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 52 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 53 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 54 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 55 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 56 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 57 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 58 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 59 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 60 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 61 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 62 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 63 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 64 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 65 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 66 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 67 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 68 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 69 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 70 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 71 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 72 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 73 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 74 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 75 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 76 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 77 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 78 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 79 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 80 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 81 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 82 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 83 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 84 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 85 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 86 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 87 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 88 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 89 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 90 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 91 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 92 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 93 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 94 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 95 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 96 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 97 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 98 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 99 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 100 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  }
];
const dummyListData = [
  {
    title: "Reimagine Health Talk",
    image: "https://appcdn.goqii.com/storeimg/usercon/rdm38344/36232_1544061429.jpg",
    video: "https://www.w3schools.com/html/mov_bbb.mp4",
    episodes: abc
  },
  {
    title: "GOQii Shorts",
    image: "https://appcdn.goqii.com/storeimg/usercon/rdm46594/58975_1708682905.jpeg",
    video: "https://www.w3schools.com/html/mov_bbb.mp4",
    episodes: abc
  }
];
const MyList = () => {
  const [open, setOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState("");
  const [selectedEpisodes, setSelectedEpisodes] = useState([]);
  const episodesRef = useRef(null);

  const handlePlayVideo = (videoUrl, episodes = []) => {
    setSelectedVideo(videoUrl);
    setSelectedEpisodes(episodes);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ padding: "16px" }}>
      {/* Title */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          mb: 2,
          textAlign: "left",
          color: "#fff",
        }}
      >
        My List
      </Typography>

      {/* List Items */}
      <Box display="flex" flexDirection="column" gap={2}>
        {dummyListData.map((item, index) => (
          <Card
            key={index}
            onClick={() => handlePlayVideo(item.video, item.episodes)}
            sx={{
              width: "100%",
              backgroundColor: "#222",
              color: "#fff",
              borderRadius: "8px",
              overflow: "hidden",
              cursor: "pointer",
              boxShadow: "0 4px 10px rgba(255, 255, 255, 0.1)",
            }}
          >
            <CardMedia
              component="img"
              height="160"
              image={item.image}
              alt={item.title}
              sx={{ filter: "brightness(0.9)" }}
            />
            <Box sx={{ padding: "8px" }}>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  color: "#fff",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {item.title}
              </Typography>
              <Typography variant="caption" sx={{ color: "#aaa", display: "block", mt: 1 }}>
                Click to watch the tutorial
              </Typography>
            </Box>
          </Card>
        ))}
      </Box>

      {/* Video Modal */}
      <VideoPlayerModalHotstar
        open={open}
        handleClose={handleClose}
        selectedVideo={selectedVideo}
        selectedEpisodes={selectedEpisodes}
        setSelectedVideo={setSelectedVideo}
        episodesRef={episodesRef}
      />
    </Box>
  );
};



export default MyList;
